import { useMutation, useQueryClient } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import LeadApi from "../api/LeadApi";
import { MODULES } from "../../../../core/data/constants/moduleConstants";
import {
  EDITED_SUCCESS_MSG,
  ERROR_MSG,
} from "../../../../core/data/constants/constant";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import {
  updateLeadsListCache,
  updateSingleLeadCache,
} from "../actions/updateLeadsListCache";
import { getAllUrlParams } from "../../../../utils/helpers/setAndGetUrlParams";
import { generateQueryParams } from "../../../../utils/helpers/generateQueryParams";
import { useSelector } from "react-redux";

const LeadIntegrations = ({ lead }) => {
  const [meetingStatus, setMeetingStatus] = useState(lead?.meetingStatus);

  const urlParams = getAllUrlParams();

  const { filters } = useSelector((state) => state.filter);
  const leadsFilters = filters.leads || [];
  let { queryParams, params } = generateQueryParams(leadsFilters);

  useEffect(() => {
    if (lead && !meetingStatus) {
      setMeetingStatus(lead?.meetingStatus);
    }
  }, [lead]);

  const mutationUpdate = useMutation({
    mutationFn: ({ id, updatedStatus, previousStatus }) =>
      LeadApi.updateLead(id, {
        meetingStatus: updatedStatus,
        textMessageAboutActivity: `<b>${MODULES.LEADS.slice(
          0,
          -1
        )} Zoom meeting status</b> updated from <b>${previousStatus}</b> to <b>${updatedStatus}</b>`,
      }),
    onSuccess: (res, { updatedStatus }) => {
      if (res?.status) {
        toast.success(res.msg || EDITED_SUCCESS_MSG);

        updateSingleLeadCache(lead?._id, res.data);

        updateLeadsListCache({
          id: lead?._id,
          updatedData: res.data,
          page: urlParams?.page * 1,
          limit: urlParams?.limit * 1,
          queryString: params?.toString(),
          queryParams: queryParams?.toString(),
          companyId: urlParams?.companyid,
        });
      }
    },
    onError: (error) => {
      toast.error(error.response?.data?.msg || ERROR_MSG);
    },
  });

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    if (newStatus !== meetingStatus) {
      mutationUpdate.mutate({
        id: lead?._id,
        updatedStatus: newStatus,
        previousStatus: meetingStatus,
      });
      setMeetingStatus(newStatus);
    }
  };

  return (
    <div className="input-group align-items-center">
      {/* Image */}
      <div className="input-group-prepend">
        <Tooltip placement="bottom" title="Zoom Meeting Status">
          <span className="input-group-text border-0 bg-transparent p-0">
            <img
              src="/assets/img/bsm/zoom-50.png"
              alt="Zoom"
              style={{
                width: "36px",
                height: "36px",
                objectFit: "cover",
                border: "1px solid #ddd",
              }}
              className="rounded-start-2"
            />
          </span>
        </Tooltip>
      </div>

      {/* Dropdown */}
      <select
        className="form-select pt-0 rounded-0 fs-6"
        style={{
          height: "36px",
          maxWidth: "160px",
        }}
        value={meetingStatus}
        onChange={handleStatusChange}
        disabled={meetingStatus === "attended" || mutationUpdate.isPending}
      >
        <option value="registered">Registered</option>
        <option value="attended">Attended</option>
        <option value="not-attended">Not Attended</option>
      </select>

      {/* Icon */}
      <div className="input-group-text" style={{ height: "36px" }}>
        {mutationUpdate?.isPending ? (
          <i className="ti ti-loader spinner fs-5" />
        ) : (
          <i
            className={`ti ti-${
              meetingStatus === "attended" ? "lock" : "pencil"
            }`}
            style={{
              color: meetingStatus === "attended" ? "#aaa" : "#000",
              cursor: meetingStatus === "attended" ? "not-allowed" : "pointer",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default LeadIntegrations;
